
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './habits.json';

const Habits = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Habit formation, routines, and behavioral psychology vocabulary. B2 level English exercises with grammar, vocab, and discussion."
            level="B2"
            title="Habits"
            image="/Images/habit1.webp"
            seoTitle="Free English Lesson Plans: Habits"
            seoDescription="Habit formation, routines, and behavioral psychology vocabulary. B2 level English exercises with grammar, vocab, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Habits;


